import { api } from './api';

/** Knowlez approval targets are knowledge artifacts — snapshots,
 *  compose outputs (drafts written by the Compose agent), briefs, and
 *  workflow steps that need a human gate. Maps 1:1 with the backend
 *  ApprovalKind union in modules/approval/approval.repository.ts. */
export type ApprovalKind = 'snapshot' | 'compose_output' | 'brief' | 'workflow_step';
export type ApprovalStatus = 'pending' | 'approved' | 'rejected' | 'cancelled';

export interface ApprovalHistoryEntry {
  step: number;
  user_id: string;
  action: 'approved' | 'rejected';
  note: string | null;
  at: string;
}

export interface Approval {
  id: string;
  workspaceId: string;
  targetKind: ApprovalKind;
  targetId: string;
  requiredSigners: string[];
  currentStep: number;
  status: ApprovalStatus;
  history: ApprovalHistoryEntry[];
  initiatedBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export const approvalsApi = {
  async list(workspaceId: string): Promise<Approval[]> {
    const r = await api.get<Approval[]>(`/api/workspaces/${workspaceId}/approvals`);
    return r.data;
  },
  async create(workspaceId: string, body: { targetKind: ApprovalKind; targetId: string; requiredSigners: string[] }): Promise<Approval> {
    const r = await api.post<Approval>(`/api/workspaces/${workspaceId}/approvals`, body);
    return r.data;
  },
  async act(id: string, body: { action: 'approve' | 'reject'; note?: string }): Promise<Approval> {
    const r = await api.post<Approval>(`/api/approvals/${id}/act`, body);
    return r.data;
  },
};
